import { 
    CART_ADD_ITEM, 
    CART_REMOVE_ITEM, 
    CART_SAVE_SHIPPING_ADRESSE, 
    CART_SAVE_PAYMENT,
    CART_MODAL_TOGGLE
} from '../constants/cartConstants'

export const cartReducer = (state = { cartItems: [], shippingAddress: {}, images: [] }, action) => {
    switch (action.type) {
        case CART_ADD_ITEM:
            const item = action.payload;
            const existItemIndex = state.cartItems.findIndex(x => x.product === item.product);
        
            if (existItemIndex !== -1) {
                // El ítem ya existe, actualizamos la cantidad
                const updatedCartItems = [...state.cartItems];
                updatedCartItems[existItemIndex] = {
                    ...state.cartItems[existItemIndex],
                    qty: state.cartItems[existItemIndex].qty + item.qty
                };
        
                return {
                    ...state,
                    cartItems: updatedCartItems
                };
            } else {
                // El ítem no existe, lo agregamos al final
                return {
                    ...state,
                    cartItems: [...state.cartItems, item]
                };
            }
        case CART_REMOVE_ITEM:
            if (action.payload === null) {
                return {
                    ...state,
                    cartItems: []
                }
            }

            return {
                ...state,
                cartItems: state.cartItems.filter((x) => x.product !== action.payload),
            }
        case CART_SAVE_SHIPPING_ADRESSE:
            return {
                ...state,
                shippingAddress: action.payload,
            }
        case CART_SAVE_PAYMENT:
            return {
                ...state,
                paymentMethod: action.payload,
            }
        case CART_MODAL_TOGGLE:
            return {
                ...state,
                showCartModal: !state.showCartModal
            }
        default: return state

    }
}